import styled from 'styled-components';

export const MappedEventsCellStyled = styled.div`
margin-top: -6px;
margin-bottom: -6px;
display: flex;
flex-direction: column;
gap: 4px;

.events {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.event {
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.gray[80]}0D;
  display: flex;

  &:hover {
    box-shadow: 0 0 1px 1px ${({ theme }) => theme.colors.gray[80]}1A;
  }
}

.info {
  padding: 6px 4px 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;

  .date {
    color: ${({ theme }) => theme.colors.gray[30]};
  }
}

.actions {
  display: flex;
  gap: 8px;
  padding: 4px 0;
}
`;
